import SubPageShell from "@/components/SubPageShell";
import ProductsSection from "@/components/ProductsSection";

export default function ProductsPage() {
  return (
    <SubPageShell testId="products-page">
      {(config) => <ProductsSection categories={config.product_categories || []} />}
    </SubPageShell>
  );
}
